import React, { Component } from "react";
import { Redirect, Link } from 'react-router-dom';
import ReactFullpage from '@fullpage/react-fullpage';
import styles from '../assets/scss/modules/kampany.module.scss';
import twitter from "../assets/media/images/Twitter.png";
import tiktok from "../assets/media/images/Tiktok.png";
import instagram from "../assets/media/images/Instagram.png";
import facebook from "../assets/media/images/Facebook.png";
import jogasz from "../assets/media/images/jogasz.png";
import kepviselo from "../assets/media/images/kepviselo.png";
import csalad from "../assets/media/images/csalad.png";
import asset1 from "../assets/media/images/asset1.png";
import asset2 from "../assets/media/images/asset2.png";
import asset3 from "../assets/media/images/asset3.png";
import asset4 from "../assets/media/images/asset4.png";
import asset5 from "../assets/media/images/Titles/aPenzugyiForrasokrol.png";
import asset6 from "../assets/media/images/asset6.png";
import back_btn from "../assets/media/newicons/back.png";
import back_btn_black from "../assets/media/newicons/back-black.png";
import forward_btn_black from "../assets/media/newicons/nextBlue.png";
import forward_btn from "../assets/media/newicons/forward.png";
import erikfoto from "../assets/media/images/Erik-foto.png";
import bild from "../assets/media/images/ProgramImages/PenzugyiForrasok.jpg";
import konczer_facebook from "../assets/media/images/konczer-facebook.png";
import gradiensProgram from "../assets/media/images/gradiensProgram.png";
import Footer from "../components/Footer/Footer";
import FooterResponziv from "../components/Footer/FooterResponziv";
import BackComponent from "../components/Kiegeszitok/BackComponent";
import BackComponentRespo from "../components/Kiegeszitok/BackComponentRespo";
import NavbarComponent from "../NavbarComponent";
import { Scrollbar } from "react-scrollbars-custom";



import{
	MDBContainer,
  MDBScrollbar,
	MDBRow,
	MDBCol,
	MDBCard,
	MDBCardHeader,
	MDBCardBody,
  MDBBtn,
} from 'mdbreact';

class PenzugyiForrasok extends Component {

	constructor(props) {
    super(props);
    this.state = {navbarPaddingTop: true,
									};
  };

	componentDidMount() {
		document.addEventListener("scroll", this.scrollEventListener);
	}

	componentWillUnmount() {
	}

	scrollEventListener = (event) => {
		const navPadding = window.scrollY < 100 ? true : false;
		this.setState({ navbarPaddingTop: navPadding});
	}


	render() {
		const anchors = ["program1", "program2", "program3"];
		let bodywrapperHeight = parseInt(window.outerWidth*0.8 + 100);
		let bodywrapperHeightText = bodywrapperHeight + "px";
    return (
			<>
			<MDBContainer fluid className="fluid-container">
				<div className="d-none d-lg-block">
					<div className={styles.bodywrapper7}>
						<BackComponent text={"MeltoIdoskor"} text2={"Méltó időskort"} program={"program8"}/>
						<img className="bild" src={bild}></img>
						<MDBContainer fluid className="program-container-programok">
							<Scrollbar
												id="scrollbar"
												style={{ width: "100%", height: "76vh", marginTop: "-5vh"}}
												maximalThumbYSize = {50}
												noScrollX = {true}
							>
								<MDBContainer fluid className="section" id="program">
									<div className={styles.bodywrapper3}>
										<MDBRow  center className="program-text-row">
										</MDBRow>
										<MDBRow  center className="program-text-row">
										<p className="jelenleg-is-ont-kepv">Jót s jól - A pénzügyi forrásokról</p>
										<p className="a-megyei-kozgyulesbe">Ma egy fejlesztésnél, projektfinanszírozásnál, költségvetési tételnél az
										elsődleges szempont nem az emberek, a közösség, a társadalom érdeke, hanem a fideszes kiváltságosok
										nyerészkedési igénye. Ezért egész szemléletünket új alapokra kell helyezni.</p>
										</MDBRow>
										<MDBRow  center className="program-text-row-end">
										<p className="a-megyei-kozgyulesbe">Tatabánya kárpótlása mellett olyan tisztességes pályázati rendszert
										vezetünk be, ahol az valósul meg, amire az embereknek szüksége van, mégpedig a lehető legköltségtakarékosabb
										módon. És nem ér hátrány települést amiatt sem, hogy ellenzéki (azaz fideszes) a vezetése.</p>
										</MDBRow>

									</div>
							</MDBContainer>

						</Scrollbar>
					</MDBContainer>

					<div className="fixed-bottom d-none d-lg-block">
					<div className="gradient"/>
						<Footer/>
					</div>
				</div>
				</div>
			</MDBContainer>

			<div className="d-block d-lg-none">
				<MDBContainer fluid className="fluid-container">
					<div className={styles.bodywrapper4}>
						<BackComponentRespo navbarPaddingTop={this.state.navbarPaddingTop} text={"MeltoIdoskor"} program={"program8"}/>
						<img className="bild2" src={bild}></img>
					</div>
					<div className={styles.bodywrapper3}>
						<img className="asset5-respo" src={asset5}></img>
						<MDBRow  center className="program-text-row m-0 px-3">
						<p className="jelenleg-is-ont-kepv">Jót s jól - A pénzügyi forrásokról</p>
						<p className="a-megyei-kozgyulesbe">Ma egy fejlesztésnél, projektfinanszírozásnál, költségvetési tételnél az
						elsődleges szempont nem az emberek, a közösség, a társadalom érdeke, hanem a fideszes kiváltságosok
						nyerészkedési igénye. Ezért egész szemléletünket új alapokra kell helyezni.</p>
						</MDBRow>
						<MDBRow  center className="program-text-row-end m-0 px-3">
						<p className="a-megyei-kozgyulesbe">Tatabánya kárpótlása mellett olyan tisztességes pályázati rendszert
						vezetünk be, ahol az valósul meg, amire az embereknek szüksége van, mégpedig a lehető legköltségtakarékosabb
						módon. És nem ér hátrány települést amiatt sem, hogy ellenzéki (azaz fideszes) a vezetése.</p>
						</MDBRow>
					</div>
				</MDBContainer>
				<MDBContainer fluid className="fluid-container">
					<div className={styles.bodywrapper5}>
						<FooterResponziv/>
					</div>
				</MDBContainer>
			</div>
      </>
    );
  }
}
export default  PenzugyiForrasok;
